import {useParams} from "react-router-dom";
import {API, Entities} from "../../utils/Api";
import {normalizeImgUrlToPreview} from "../../utils/Helper";

export function Presenter({presenter}){
    const currentDate = new Date();
    var awards = presenter.awards?JSON.parse(presenter.awards):[];
    var previewUrl= normalizeImgUrlToPreview(presenter.imgUrl);

    function getRelevantEvent(events) {
        let nextEvent = null;
        let lastEvent = null;
        let minFutureDiff = Infinity; // Legközelebbi jövőbeli előadás
        let minPastDiff = Infinity;   // Legutolsó múltbeli előadás

        if(events) {
            events.forEach(event => {
                const eventEnd = event.to ? new Date(event.to) : null;

                if (eventEnd) {
                    const timeDiff = eventEnd - currentDate;

                    if (timeDiff > 0 && timeDiff < minFutureDiff) {
                        minFutureDiff = timeDiff;
                        nextEvent = event;
                    }
                    else if (timeDiff < 0 && Math.abs(timeDiff) < minPastDiff) {
                        minPastDiff = Math.abs(timeDiff);
                        lastEvent = event;
                    }
                }
            });
        }


        return nextEvent || lastEvent || null;
    }

    const closestEvent = getRelevantEvent(presenter.presentations);

    return (
        <section>
            <div className="container">
                <div className="row align-items-center justify-content-center">
                    <div className="col-lg-6 text-end md-mb-50px"
                         data-anime='{ "effect": "slide", "color": "#18bcc7", "direction":"lr", "easing": "easeOutQuad", "delay":50}'>
                        <figure className="position-relative m-0">
                            <img className="border-radius-6px box-shadow-double-large lg-w-85"
                                 src={previewUrl??"https://placehold.co/478x600"} alt=""/>
                            {   awards.length>0 &&
                                <figcaption
                                className="position-absolute border-radius-10px bottom-minus-50px lg-bottom-60px sm-bottom-40px left-minus-30px md-left-0px w-230px xs-w-210px text-center last-paragraph-no-margin animation-float">
                                    <img src={awards[0].imgUrl} alt=""/>
                                </figcaption>
                            }
                        </figure>
                    </div>
                    <div className="col-lg-5 offset-lg-1"
                         data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                        <span
                            className="fs-18 fw-600 text-dark-gray mb-20px d-flex align-items-center">{presenter.category}</span>
                        <h2 className="fw-800 text-dark-gray ls-minus-2px mb-40px">{presenter.name}</h2>
                        <div className="row row-cols-1 justify-content-center mb-40px">
                            <div className="col icon-with-text-style-08 mb-25px">
                                <div className="feature-box feature-box-left-icon overflow-hidden">
                                    <div className="feature-box-content last-paragraph-no-margin"><span
                                        className="d-inline-block fs-18 fw-700 text-dark-gray ls-minus-05px mb-5px">{presenter.position}</span>
                                        <p className="w-85 lg-w-100">{presenter.companyName??"Független"}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col icon-with-text-style-08">
                                <div className="feature-box feature-box-left-icon overflow-hidden">
                                    <div className="feature-box-content last-paragraph-no-margin"><span
                                        className="d-inline-block fs-18 fw-700 text-dark-gray ls-minus-05px mb-5px">DÍJAK</span>
                                        {awards.map((award,idx)=> {
                                            return <p key={idx} className="w-85 lg-w-100">{award.name}</p>
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'m-5'}></div>
                    <div className="row align-items-center justify-content-center mb-15px">
                        <div
                            className="col-12 col-lg-4 col-md-5 alt-font text-dark-gray text-center text-md-end fw-500 text-uppercase">KAPCSOLÓDJ
                            AZ ELŐADÓVAL
                        </div>
                        <div className="col-12 col-lg-2 col-md-2">
                            <div className="w-100 h-1px bg-extra-medium-gray sm-mt-15px sm-mb-15px"></div>
                        </div>
                        <div
                            className="col-12 col-lg-4 col-md-5 text-center text-md-start elements-social social-icon-style-02">
                            <ul className="medium-icon dark mb-0">
                                {presenter.linkedInUrl && <li>
                                    <a className="linkedin" href={presenter.linkedInUrl}
                                       target="_blank"><i
                                        className="fa-brands fa-linkedin-in"></i></a>
                                </li>}
                                {presenter.facebookUrl && <li>
                                    <a className="facebook" href={presenter.facebookUrl}
                                       target="_blank"><i
                                        className="fa-brands fa-facebook-f"></i></a>
                                </li>}
                            </ul>
                        </div>
                    </div>
                <div className={'m-5'}></div>
                        <div className="row overlap-gap-section">
                            <div className="col-lg-4 col-md-6 sm-mb-30px text-center text-md-start"><span
                                className="alt-font text-dark-gray fs-24 fw-500 d-inline-block mb-15px ls-minus-05px">Következő előadás</span>
                                <ul className="list-style-01 ps-0 pe-50px mb-0 sm-pe-0">
                                    <li className="border-color-extra-medium-gray pt-15px pb-15px">
                                        <span
                                            className="text-dark-gray w-35 sm-w-auto sm-me-20px d-inline-block fw-500 alt-font fs-16">Kezdete</span>
                                        {closestEvent?closestEvent.from:"Nincs előadás"}
                                    </li>
                                    <li className="border-color-extra-medium-gray pt-15px pb-15px">
                                        <span
                                            className="text-dark-gray w-35 sm-w-auto sm-me-20px d-inline-block fw-500 alt-font fs-16">Cím</span>{closestEvent?closestEvent.title:"Nincs előadás"}
                                    </li>
                                    <li className="pt-15px pb-15px fs-16">
                                        <span
                                            className="text-dark-gray w-35 sm-w-auto sm-me-20px  d-inline-block fw-500 alt-font">Cég</span>{presenter.companyName??"Független"}
                                    </li>
                                </ul>
                            </div>
                             <div className="col-lg-6 offset-lg-1 col-md-6 text-center text-md-start">
                                <h6 className="alt-font fw-500 text-dark-gray mb-20px">ELŐADÁS TARTALMA</h6>
                                <p>{closestEvent?closestEvent.description:""}</p>
                                 {(presenter.companyUrl>'') &&
                                    <a {...(presenter.companyUrl ? {href: presenter.companyUrl} : {})}
                                       className="btn btn-medium btn-transparent-light-gray">Információk a cégről</a>
                                 }
                            </div>
                        </div>
            </div>
        </section>
)
}